export default __webpack_public_path__ + "76767a91f671f09a86d5dfc69496a977.gif";